import { apiClient } from "./client";
import type { ImportSubscriptionCsvResultDto } from "./types";

/**
 * §7.4 导入 Kiro 控制台订阅 CSV 核对台账(仅 Admin)。
 * csvContent 是读取上传文件后的原始文本内容,不做客户端解析,交给后端
 * `csv_subscription_import_service.py` 用标准 CSV 解析器处理
 * (Activation date 列值内部带逗号、用双引号包裹,手写按逗号分割在前端做
 * 一次、后端再做一次容易出现两套解析逻辑不一致,不如只在后端解析一次)。
 *
 * `confirm`(默认 false = 预览):两步确认机制(§7.4.1),第一次调用不传或
 * 传 false,只预览不写入台账;管理员核实预览结果符合预期后,第二次调用
 * 传 true 才真正写入 + 记审计。防止目标账号选错、恰好与 CSV 真实所属账号
 * 邮箱重叠时,静默覆盖不相关账号的真实记录。
 */
export function importSubscriptionCsv(accountId: string, csvContent: string, confirm: boolean = false) {
  return apiClient.post<ImportSubscriptionCsvResultDto>("/consistency/import-subscription-csv", {
    account_id: accountId,
    csv_content: csvContent,
    confirm,
  });
}
